import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Tractor, TrailerIntervention, TrailerInterventionStatus} from 'shared';

@Component({
  selector: 'app-map-intervention-popup',
  templateUrl: './map-intervention-popup.component.html',
  styleUrls: ['./map-intervention-popup.component.scss']
})
export class MapInterventionPopupComponent implements OnInit {

  @Output()
  onClose: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  intervention?: TrailerIntervention;

  @Input()
  tractor?: Tractor;

  @Input()
  status?: TrailerInterventionStatus;

  constructor() {
  }

  ngOnInit(): void {
  }

  close() {
    this.onClose.emit();
  }
}
